const REVENUE_OPTIONS = {
  CONFIRMED: 'confirmed',
  RESERVED: 'reserved'
};

export const buildEmptyTableColumn = () => {
  return {
    date: '',
    report: {
      [REVENUE_OPTIONS.CONFIRMED]: {
        value: '',
        tooltipData: []
      },
      [REVENUE_OPTIONS.RESERVED]: {
        value: '',
        tooltipData: []
      }
    }
  };
};

export const buildBookingStateRevenueTableData = data => {
  return {
    tableRows: [
      {
        labelForSideMenu: 'Confirmed £',
        labelForLegend: 'Confirmed',
        key: REVENUE_OPTIONS.CONFIRMED
      },
      {
        labelForSideMenu: 'Reserved (Forecast) £',
        labelForLegend: 'Reserved (forecast)',
        key: REVENUE_OPTIONS.RESERVED
      }
    ],
    data: data.map(dataPoint => {
      const {confirmed, reserved} = dataPoint.report;
      const confirmedRow = Number(confirmed);
      const reservedRow = Number(reserved);
      const confirmedTooltipData = [
        {label: 'Total Confirmed', value: confirmedRow}
      ];

      const reservedTooltipData = [
        {label: 'Total Reserved', value: reservedRow}
      ];

      return {
        date: dataPoint.date,
        report: {
          [REVENUE_OPTIONS.CONFIRMED]: {
            value: confirmedRow,
            tooltipData: confirmedTooltipData
          },
          [REVENUE_OPTIONS.RESERVED]: {
            value: reservedRow,
            tooltipData: reservedTooltipData
          }
        }
      };
    })
  };
};
